module.exports = __webpack_public_path__ + "img/liucheng.68eea991.png";